import { ComparePage } from '@/components/marketing/compare-page'

export function CompareNotebooklmPage() {
  return (
    <ComparePage
      contentKey="compareNotebooklm"
      path="/compare/notebooklm"
      otherLabel="NotebookLM"
      relatedKeys={['comparePerplexity', 'whatIsKnowledgeGraph', 'useCasesStudents']}
    />
  )
}
